import { cyoStore }  from '../cyo/cyo';
export default {
	resetSettingFilterPage(state) {

		Object.assign(state, 

			{

            // setting: {
                // setting, diamond
                skeleton:false,
                page:null,
                // ringm, earring, pendant
                moduleType: null, 
                moduleSubType: null, 
                filters : null,
                options: null,
                payload:null,
                compare_list:[],
                compare_list_count:0,
                results:{
                    data:[],
                    total:null,
                    next_page_url:null,
                    current_page:null,
                }
            // }


		});

    },

	setSettingShowSkeleton(state, data) {
		state.skeleton = data.flag
    },
	setSkeletonShowMore(state, data) {

		state.showMoreSkeleton = data.flag
    },
	unsetSettingFilterShapeFilter(state, data) {
		
		state.filters.splice( state.filters.map(e => e.name).indexOf('shape'), 1 )
    },

	disableDiamondFilterShapes(state, data) {
        
        state.options.shape = state.options.shape.map( (cv) =>{
            
            if ( ! data.setting.avail_shapes.includes( cv.value )  ) {

                // cv.active = 0
                cv.disabled = 1
            }

            return cv
        })
    },


	setCyoSettingFilter(state, data) {
       

        // console.log('statetauysvfda ', state, data)
		state.filters             = data.filters
		state.moduleType	      = data.moduleType
        state.moduleSubType       = data.moduleSubType
		state.page	              = data.page
    },
   	
   	setCyoSettingFilterOptions(state, data) {

        // console.log('setCyoSettingFilterOptions',state, data.price )
		state.options = {...data}
    },


	setRequestPayload(state, payload) {

		state.payload = payload
    },

    setRequestFilterTags(state, tags) {

		state.filterTags = tags
    },

	setSettingListingResults(state, data) {

        // console.log('res', data)
        // state.error = data.error
        if( data.response.error === 'client_network_error' ){

            state.error = data.response.error
            return
        }
        
        state.error = null

        // add delay key in array
        let transitionDelayKey =  0;


        const compare_list = state.compare_list

        const modifiedData = data.response.data.map( (item) => {

            const in_compare = state.compare_list.find( (c) => c.id === item.id )
            
            if( in_compare ){

                item.is_compared_count = 1
            }

            item.uniqueKey = "id" + Math.random().toString(12).slice(2) + '' + item.id
            transitionDelayKey++
            return { ...item, transitionDelayKey: transitionDelayKey }
        }) 

        const resData = []
        
        modifiedData.forEach((product, index) => {
            resData.push(product);
            if(state.page === 'diamond'){
                if ((index + 1) % 12 === 0) {
                    resData.push({ isQuiz: true });
                }
            }
        });

        // add it inn state
		if( ! data.clearListing){

			state.results.data = [...state.results.data, ...resData]
		}
		else{

			state.results.data = resData
		}
		state.results.next_page_url = data.response.next_page_url
		state.results.total = data.response.total
		state.results.current_page = data.response.current_page
    },

    toggleSettingFilterVisibility( state, data ){


        state.filters = state.filters.map( (filter) => {

                        if (data.reset) {

                            filter.isOpen = false
                            return filter
                        }

                        if (filter.name  === data.filter.name) {

                            filter.isOpen = !filter.isOpen
                        }
                        else{

                            filter.isOpen = false
                        }

                        return filter
                    })
    },

   	toggleSettingListingShowMore( state ){

   		const payload = state.payload

   		if (payload && payload.page ) {

   			state.payload.page = state.payload.page + 1

   		}
   	},

	toggleSettingFilterSelectGroup( state, data ){

		state.options[ data.filter.name ].forEach( (v,k) => {
            v.options.forEach( (v,k) => { 
                v.active = 0
                if (v.value === data.event.target.value ) {
                    v.active = 1
                }
            })
        })

    },

    toggleSettingFilterCheckbox( state, data ){


		state.options[ data.filter.name ].forEach( (option,key) => {
            
            if (option.value === data.option.value) {

            	option.active = (option.active === 1) ? 0 : 1

            }
        })

    },


    toggleSettingFilter( state, data ){
     
        const cyo = cyoStore()
		const filter = state.filters.find( ( cv ) => cv.name === data.filter.name )
		
    	state.options[ data.filter.name ]

    	.map( ( cv ) =>  {
            
    		//disable all other if single select
            if (filter.singleSelect ) {

                // cv.active = 0
            }

       		// disable all if reset
            if (data.reset ) {

                cv.active = 0
            }
        
			// activate default 
            if(!data.reset){
                if (filter.singleSelect) {
                    if ( cv.value === data.option.value ) {
                        cv.active = cv.active === 1 ? 0 : 1
                    }else{
                        cv.active = 0
                    }
                }
                else if(cv.value === data.option.value){
                    cv.active = cv.active === 1 ? 0 : 1
                }
            }
    	})
      

        if ( data.flagSetCyoShape && state.moduleType === 'cyo' && data.filter.name === 'shape'  ) {

            const shape = state.options[ data.filter.name ].find( (cv) => cv.active === 1 )
            
            cyo.setShape({ shape: shape?.value ? shape : {value:null}, moduleSubType: state.moduleSubType } )


        }
    },


    setDiamondCompareListItems(state, data) {

        // add delay key in array
        let transitionDelayKey =  0;

        const resData = data.data.map( (item) => {

            transitionDelayKey++

            // update result table in compare
            const d = state.results.data.find( d => d.id === item.id )
            if( d ){

                d.is_compared_count = 1
            }

            return { ...item, transitionDelayKey: transitionDelayKey }
        }) 
        state.compare_list = resData

    },

    setDiamondCompareListCount(state, count) {

        state.compare_list_count = count
    },

    setShowMoreLoader(state, data) {

        state.results.next_page_url = data.flag
    },

    markAddOrRemoveFromCompare( state, data ){

        const d = state.results.data.find( d => d.id === data.item_id )

        if(d){

            data.action === 'add' ? d.is_compared_count = 1 : d.is_compared_count = 0
        }        

        // remove from compare list
        state.compare_list = state.compare_list.filter( ( cv ) => cv.id !== data.item_id )


    }

}





































// // Define and export the actions function
// export default function useMutations(){

//   function setupCyoSettingFilter(state, { moduleType, moduleSubType, filters, page }) {

//     state.moduleType.value = moduleType;
//     state.moduleSubType.value = moduleSubType;
//     state.filters.value = filters;
//     state.page.value = page;
//   }

//   function setSettingListingResults(state, data) {

//     // console.log('res', data)
//     // state.error = data.error
//     if( data.response.error === 'client_network_error' ){

//         state.error = data.response.error
//         return
//     }
    
//     state.error.value = null

//     // add delay key in array
//     let transitionDelayKey =  0;


//     const compare_list = state.compare_list

//     const resData = data.response.data.map( (item) => {

//         const in_compare = state.compare_list.value.find( (c) => c.id === item.id )
        
//         if( in_compare ){

//             item.is_compared_count = 1
//         }


//         transitionDelayKey++
//         return { ...item, transitionDelayKey: transitionDelayKey }
//     }) 

//     // add it inn state
//     if( ! data.clearListing){

//         state.results.data = [...state.results.data, ...resData]
//     }
//     else{

//         state.results.data = resData
//     }
//     state.results.next_page_url = data.response.next_page_url
//     state.results.total = data.response.total
//     state.results.current_page = data.response.current_page
//   }

//   function setCyoSettingFilterOptions(state, data) {
    
//     console.log('setCyoSettingFilterOptions', state, data)
//     state.options = data
//   }

//   return {
//     setupCyoSettingFilter,
//     setSettingListingResults,
//     setCyoSettingFilterOptions
//   };
// }
